import { Component, OnInit, OnDestroy, EventEmitter, Output, Input } from '@angular/core';
import { FormControl } from '@angular/forms';
import {
  NstiStockContainerModel, NstiStockService, Pagination,
} from 'blg-akaun-ts-lib';
import { AppConfig } from '../../visa';
import { forkJoin, iif, Observable, of, ReplaySubject, Subject } from 'rxjs';
import { debounceTime, tap, filter, switchMap, distinctUntilChanged, map, mergeMap, takeUntil } from 'rxjs/operators';
import { SubSink } from 'subsink2';

@Component({
  selector: 'app-select-nsti-drop-down',
  templateUrl: './select-nsti-drop-down.component.html',
  styleUrls: ['./select-nsti-drop-down.component.scss']
})

export class SelectNSTIDropDownComponent implements OnInit, OnDestroy {
  private subs = new SubSink();
  private apiVisa = AppConfig.apiVisa;
  @Input() nsti = new FormControl();
  @Input() guid_fi_item_hdr;
  @Input() isTradeIn : boolean;
  @Input() isReturn : boolean;
  @Output() nstiSelected = new EventEmitter<NstiStockContainerModel>();
  @Output() nstiChange = new EventEmitter<FormControl>();

  serverSideFiltering = new FormControl();
  serverSideSearching = false;
  filteredOptions$: ReplaySubject<NstiStockContainerModel[]> = new ReplaySubject<NstiStockContainerModel[]>(1);
  nstiList: NstiStockContainerModel[] = [];
  selectedNSTI: NstiStockContainerModel;
  filterControl = new FormControl();
  protected _onDestroy = new Subject<void>();

  constructor(
    private nstiService: NstiStockService
  ) {
  }

  ngOnInit() {
    const paging = new Pagination();
    paging.conditionalCriteria.push({
      columnName: 'guid_fi_item_hdr',
      operator: '=',
      value: this.guid_fi_item_hdr.toString(),
    });
    if(!this.isReturn){
      paging.conditionalCriteria.push({
        columnName: 'quantity_balance_greater_than',
        operator: '=',
        value: "0",
      });
    }
  
    this.subs.sink = this.nstiService.getByCriteria(paging,this.apiVisa).subscribe(
      {next: resolve => {
        this.nstiList = resolve.data;
        if(resolve.data && resolve.data.length===1){
          this.onSelect(resolve.data[0].bl_fi_nsti_stock_hdr.guid.toString());
        }
        this.filteredOptions$.next(this.nstiList);
      }});
    this.subs.sink = this.filterControl.valueChanges.pipe(
      debounceTime(300),
      distinctUntilChanged()
    ).subscribe({next: resolve => this.filterNSTI(resolve)});
  }

  

  filterNSTI(search: string) {
    if (!search) {
      this.filteredOptions$.next(this.nstiList);
    } else {
      search = search.toLocaleLowerCase();
      const filter = this.nstiList.filter(c => 
        c.bl_fi_nsti_stock_hdr.name.toLocaleLowerCase().includes(search)  ||
        c.bl_fi_nsti_stock_hdr.serial_no.toLocaleLowerCase().includes(search)
      );
      this.filteredOptions$.next(filter);
    }

  }

  onSelect(guid: string) {
    if (guid) {
      this.nsti.patchValue(guid);
      this.selectedNSTI = this.nstiList.find(n => n.bl_fi_nsti_stock_hdr.guid === guid);
      this.nstiSelected.emit(this.selectedNSTI);
    }
  }


  ngOnDestroy() {
    this._onDestroy.next();
    this._onDestroy.complete();
  }
}
